export default "__VITE_ASSET__5YAB47o___"